import { useState } from "react";
import { useRepositoriesContext } from "../../contexts/RepositoriesContext";
import { CreateUserDto } from "../../core/models/dtos/CreateUserDto";
import { useTranslation } from "react-i18next";
import { withToasts } from "../components/Toast/Toast";
import { createUserWithToasts } from "../screens/customer-update/models/createUserFlow";

export function useOrganizationUsers(organizationId: number, options?: { enabled?: boolean }) {
  const { userRepository } = useRepositoriesContext();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const {
    data: users,
    isError: isUsersError,
    isLoading: isUsersLoading,
    isSuccess: isUsersSuccess,
  } = userRepository.useUsersOfOrganization(organizationId, options);

  function handleCreateUser(user: CreateUserDto) {
    // createUserFlow (flag userCreateMailStatusEnabled): "created, mail not
    // sent" resolves (the act-as dialog closes and auto-selects the new user)
    // with a warning toast; flag off = exactly today's English toasts.
    user.organizationId = organizationId;
    return createUserWithToasts({
      create: () => userRepository.createUser(user),
      email: user.email,
      t,
      loadingMessage: "Creating user",
      successMessage: "User created",
      setIsLoading,
    });
  }

  function handleDeleteUser(userId: number) {
    async function transaction() {
      return await userRepository.deleteUser(userId, organizationId);
    }

    return withToasts(
      transaction,
      "Deleting user",
      "User deleted",
      "Failed to delete user",
      setIsLoading
    );
  }

  return {
    users: users || [],
    onCreateUser: handleCreateUser,
    onDeleteUser: handleDeleteUser,
    isLoading: isLoading || isUsersLoading,
    isError: isUsersError,
    isSuccess: isUsersSuccess
  };
}
